"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var UserStar = function UserStar(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className, " d8-svg-").concat(name),
    version: "1.1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "40",
    height: "40",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "matrix(1.6666666666666667,0,0,1.6666666666666667,0,0)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.2,15c0.504-1.219,1.697-2.01,3.016-2c0.136,0,0.247-0.11,0.248-0.246c0-0.068-0.028-0.134-0.078-0.181 c-2.976-2.851-7.699-2.75-10.55,0.226c-0.826,0.863-1.434,1.911-1.771,3.057c-0.079,0.265,0.072,0.543,0.336,0.622 c0.046,0.014,0.094,0.021,0.143,0.021H8.47c0.266,0,0.486-0.208,0.5-0.474C8.988,15.673,9.066,15.326,9.2,15z M7.044,0 c2.623,0,4.75,2.127,4.75,4.75S9.667,9.5,7.044,9.5s-4.75-2.127-4.75-4.75S4.421,0,7.044,0z M20.693,23.827 c0.484,0.281,1.095,0.214,1.506-0.166c0.41-0.363,0.538-0.95,0.315-1.45L21.29,19.4c-0.043-0.099-0.017-0.214,0.063-0.286 l2.213-1.972c0.371-0.355,0.489-0.9,0.3-1.377C23.672,15.294,23.209,14.99,22.7,15h-2.5c-0.1,0-0.19-0.059-0.229-0.151 l-1.344-3.116L18.61,11.7c-0.325-0.636-1.105-0.888-1.741-0.563c-0.252,0.129-0.454,0.336-0.577,0.591l-1.346,3.116 c-0.039,0.092-0.129,0.151-0.229,0.151h-2.5c-0.508-0.012-0.972,0.29-1.166,0.76c-0.193,0.488-0.066,1.044,0.32,1.4l2.194,1.955 c0.08,0.072,0.106,0.187,0.063,0.286L12.4,22.21c-0.224,0.5-0.097,1.088,0.314,1.451c0.413,0.377,1.021,0.444,1.506,0.166 l3.112-1.752c0.076-0.043,0.169-0.043,0.245,0L20.693,23.827z",
    fill: fill,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "0",
    stroke: "none"
  })));
};
UserStar.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
UserStar.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = UserStar;